<template>
  <v-container class="contact">
    <v-row align="center">
      <v-col cols="12" sm="6">
        <span class="contact-title"
          >Nous sommes <br />
          là pour vous</span
        >
      </v-col>
      <v-col cols="12" sm="6">
        <v-form v-model="valid" @submit.prevent="sendRequest">
          <v-row align="center" no-gutters class="mb-2">
            <v-text-field
              placeholder="Nom"
              required
              v-model="data.name"
              filled
              rounded
              :rules="[
                v => !!v || 'Un nom est requis',
                v => v !== null || 'Un nom est requis'
              ]"
            ></v-text-field>
          </v-row>
          <v-row align="center" no-gutters class="mb-2">
            <v-text-field
              placeholder="Compagnie"
              v-model="data.company"
              filled
              rounded
            ></v-text-field>
          </v-row>
          <v-row align="center" no-gutters class="mb-2">
            <v-text-field
              placeholder="Courriel"
              required
              v-model="data.email"
              rounded
              filled
              type="email"
              :rules="emailRules"
            ></v-text-field>
          </v-row>
          <v-row align="center" no-gutters class="mb-2">
            <v-textarea
              auto-grow
              rounded
              placeholder="Message"
              filled
              v-model="data.message"
              :rules="[
                v => !!v || 'Veuillez inscrire un message',
                v => v !== null || 'Veuillez inscrire un message'
              ]"
            ></v-textarea>
          </v-row>
          <v-row align="center" justify="center" no-gutters>
            <v-btn
              v-if="showComfirmMessage === false"
              type="submit"
              class="contact-button"
              rounded
              color="#FFB300"
              :loading="loading"
              :disabled="valid === false"
              large
            >
              <span class="font-capitalize">Envoyer</span>
            </v-btn>
            <v-icon
              v-if="showComfirmMessage === true"
              color="success"
              class="mr-2"
              >far fa-check-circle</v-icon
            >
            <span
              v-if="showComfirmMessage === true"
              class="contact-comfirm-message"
              >Nous vous contactons dès que possible!</span
            >
          </v-row>
        </v-form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from "@/api";
export default {
  name: "Contact",
  data() {
    return {
      valid: false,
      data: {
        name: null,
        company: null,
        email: null,
        message: null
      },
      emailRules: [
        v => !!v || "Une adresse courriel est requise",
        v =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
          "Doit être une adresse valide"
      ],
      loading: false,
      showComfirmMessage: false
    };
  },
  methods: {
    async sendRequest() {
      if (this.valid === true) {
        try {
          this.loading = true;
          await api.sendInfosRequest(this.data);
          this.showComfirmMessage = true;
        } finally {
          this.loading = false;
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.contact {
  margin-top: 5rem;
  margin-bottom: 5rem;
  .contact-button {
    width: 160px;
  }
  .contact-title {
    font-size: 3rem;
    font-weight: 500;
    line-height: 1;
  }
  .contact-comfirm-message {
    font-size: 1.4rem;
    font-weight: 500;
    color: #46c93a;
  }
}
</style>
